import React from 'react'
import { Dotsmenu } from '@e3dc-react/icons'
import { Box, IconButton } from '@mui/material'
import EMobilityChargingCardTableMenu from './EMobilityChargingCardTableMenu'
import { EMobilityChargingCardsDataModel } from './models/e-mobility-charging-cards-models'

interface EMobilityChargingCardTableMenuIconProps {
  data: EMobilityChargingCardsDataModel
  storageId: string
}

const EMobilityChargingCardTableMenuIcon: React.FC<EMobilityChargingCardTableMenuIconProps> = ({ data, storageId }): React.ReactElement => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const isOpen = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (): void => {
    setAnchorEl(null)
  }
  return (
    <Box>
      <IconButton onClick={handleClick}>
        <Dotsmenu />
      </IconButton>
      <EMobilityChargingCardTableMenu data={data} storageId={storageId} isOpen={isOpen} anchorEl={anchorEl} handleClose={handleClose} />
    </Box>
  )
}

export default EMobilityChargingCardTableMenuIcon
